
import { getBytesCount } from "@utils/data"
const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateTitle = (rule, value, callback,context) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else if (getBytesCount(value) > 100) {
        callback(new Error('最多100个字符'))
    } else {
        callback();
    }
}
// 新规校验标题
// 限制则执行60个字符（30个汉字）
const validateTitle2 = (rule, value, callback,context) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    const splitArr = value.split('')
    let totalNum = 0
    let maxNum = context?.validateFieldMap?.popNameLength || 60
    splitArr.forEach(s => {
        totalNum += /[\u4e00-\u9fa5]/.test(s) ? 2 : 1
    })
    if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else if (totalNum > maxNum) {
        callback(new Error(`最多输入${parseInt(maxNum/2)}个字（${maxNum}个字符）`))
    } else {
        callback();
    }
}

const validateSkuPrice = (value, prop) => {
    if (value === '' || value === null || value === undefined) {
        return prop.label + '不能为空值!'
    }
    value = String(value).trim();
    const valueNum = Number(value);
    const idx = value.indexOf('.');
    if (isNaN(valueNum) || valueNum < 0) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    }
    if (idx !== -1) {
        const mStr = value.slice(idx + 1);
        if (mStr.length > 2) {
            return prop.label + '必须为大于等于0的正数且支持小数点后2位';
        }
    }
    return false;
}

const validateSlogan = (rule, value, callback, context) => {
    const _slogan = context.self_form.slogan || "";
    const _sloganLinkWord = context.self_form.sloganLinkWord || "";

    if ((_slogan.length + _sloganLinkWord.length) > 80) {
        callback(new Error('“商品标语”+“标语链接”文字最多输入80个字符'))
    } else {
        callback()
    }
}
const validateSloganLinkWord = (rule, value, callback, context) => {
    const _slogan = context.self_form.slogan || "";
    const _sloganLinkWord = context.self_form.sloganLinkWord || "";
    const _linkAddress = context.self_form.linkAddress || "";

    if ((_slogan.length + _sloganLinkWord.length) > 80) {
        callback(new Error('“商品标语”+“标语链接”文字最多输入80个字符'))
    } else if ((!_sloganLinkWord.length && _linkAddress.length) || (_sloganLinkWord.length && !_linkAddress.length)) {
        callback(new Error('链接的文字及地址需同时填写或同时不填'))
    } else {
        callback()
    }
}
const validateLinkAddress = (rule, value, callback, context) => {
    const _sloganLinkWord = context.self_form.sloganLinkWord || "";
    const _linkAddress = context.self_form.linkAddress || "";
    if (value && !(/(jd\.com)|(360buy\.com)|(jd\.hk)|(360buy\.hk)|(isvjcloud\.com)/.test(value))) {
        callback(new Error('地址请使用jd.com、360buy.com或jd.hk、360buy.hk或isvjcloud.com的链接!'))
    } else if ((!_sloganLinkWord.length && _linkAddress.length) || (_sloganLinkWord.length && !_linkAddress.length)) {
        callback(new Error('链接的文字及地址需同时填写或同时不填'))
    } else {
        callback()
    }
}


// 校验商品长宽高
const validateLWH = (rule, value, callback, context) => {
    if(value) {
        const _number = Number(value)
        if (isNaN(_number) || _number < 1 || _number > 99999) {
            callback(new Error('请输入1到99999之间整数'))
        } else {
            callback()
        }
    } else {
        callback()
    }
}

// 校验重量是否填写
const validateWeight = (rule, value, callback) => {
    const _number = Number(value)
    if (_number === 0) {
        callback(new Error('请输入商品毛重'))
    } else {
        callback()
    }
}

const validateJdPrice = (rule, value, callback, context) => {
    const jdPrice = value;
    const marketPrice = context.self_form.marketPrice;
    if (Number(jdPrice) > Number(marketPrice)) {
        callback(new Error('京东价<=市场价'))
    } else {
        callback()
    }
}

const validateMarketPrice = (rule, value, callback, context) => {
    context.$refs.form.validateField('jdPrice');
    callback()
}
const validateImageUrls = (rule, value, callback) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length < 1 || sum === 0) {
        callback(new Error('至少要选择1张图片'));
    } else {
        callback()
    }
    
}
const validateTransImg = (rule, value, callback) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length < 1 || sum === 0) {
        callback(new Error('请上传透图'));
    } else {
        callback()
    } 
}

const validateEditor = (rule, value, callback) => {
    if (value.length > 100000) {
        callback(new Error('长度不允许超过10w'));
    } else {
        callback()
    } 
}

const validateBrandId = (rule, value, callback, context) => {
    if (context.$refs.brandIdBlock) {
        let msg = context.$refs.brandIdBlock.method_validate()
        msg ? callback(new Error("请完善品牌部分")) : callback()
    } else {
        callback()
    }
}

const validatePromise = (rule, value, callback, context) => {
    let requiredList = (context.promiseConfList || []).find(item => item.requiredFlag && !context.promiseTemplateValues[item.shopId])
    requiredList ? callback(new Error('请选择发货时效')) : callback();
}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    return {
        categoryIds: [
            {required: true, message: '请选择类目'},
            {validator: validateCategoryIds}
        ],
        title: [
            {required: true, message: '请输入商品名称'},
            {validator: contextWrap(validateTitle, context)},
        ],
        slogan: [
            {validator: contextWrap(validateSlogan, context)}
        ],
        sloganLinkWord: [
            {validator: contextWrap(validateSloganLinkWord, context)}
        ],
        linkAddress: [
            {validator: contextWrap(validateLinkAddress, context)}
        ],
        // itemNum: [
        //     {required: true, message: '请输入货号'}
        // ],
        length: [
            {required: context.isShowLWH || context.isVolume, message: '请输入商品长度'},
            {validator: validateLWH, trigger: 'blur'}
        ],
        width: [
            {required: context.isShowLWH || context.isVolume, message: '请输入商品宽度'},
            {validator: validateLWH, trigger: 'blur'}
        ],
        height: [
            {required: context.isShowLWH || context.isVolume, message: '请输入商品高度'},
            {validator: validateLWH, trigger: 'blur'}
        ],
        weight: [
            {required: context.isShowLWH || context.isWeight, message: '请输入商品毛重'},
            {validator: validateWeight, trigger: 'blur'}
        ],
        jdPrice: [
            {required: true, message: '请输入京东价'},
            {validator: contextWrap(validateJdPrice, context)}
        ],
        marketPrice: [
            {required: true, message: '请输入市场价'},
            {validator: contextWrap(validateMarketPrice, context)}
        ],
        images: [
            {required: true, message: '图片至少上传一张'},
            {validator: validateImageUrls}
        ],
        transparentImages: [
            {required: true, message: '请上传商品透图'},
            {validator: validateTransImg}
        ],
        introduction: [
            {required: true, message: '请输入电脑版商品详情'},
            {validator: validateEditor}
        ],
        mobileDesc: [
            {required: true, message: '请输入手机版商品详情'},
            {validator: validateEditor}
        ],
        brandId: [],
        promiseConfig: [
            {validator: contextWrap(validatePromise, context)}
        ]
    };
}

export {
    RULES as default,
    validateTitle,
    validateTitle2,
    validateBrandId,
    validateSkuPrice,
    contextWrap
};